var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('CAppInsights',{ref:"ai"}),_vm._v(" "),_c('button',{staticClass:"button button--primary sz-4",attrs:{"id":"open-dialog-button"},on:{"click":function($event){return _vm.openDialog()}}},[_vm._t("button-text")],2),_vm._v(" "),_vm._t("description")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }